import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withKeys as _withKeys, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ss-card-acao-extra-superior-direita" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_4 = {
  class: "ant-row",
  style: {"max-height":"30px"}
}
const _hoisted_5 = {
  key: 0,
  class: "ant-col ant-col-xs-2 ant-col-xl-1"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_13 = {
  key: 0,
  type: "button",
  class: "ant-btn ant-btn-block"
}
const _hoisted_14 = {
  key: 1,
  class: "ant-btn-group ss-tamanho-completo"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_estoque = _resolveComponent("selecionar-estoque")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_produto_detalhes = _resolveComponent("produto-detalhes")!
  const _component_leitor_codigo_camera = _resolveComponent("leitor-codigo-camera")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_card, {
          titulo: _ctx.montaTituloContagem(),
          class: _normalizeClass(_ctx.state.mensagemSalvandoContagem === ''?'':'ss-bloquear-tela')
        }, {
          AcoesExtra: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_tooltip, {
                placement: "top",
                title: "Adiciona uma quantidade automaticamente na contagem após identificar o produto pelo código, leitor ou câmera."
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, {
                    class: "ss-fonte-negrito ss-alinhar-direita",
                    checked: _ctx.state.autoIncrementar,
                    "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.autoIncrementar) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Automatizar contagem ")
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_form_item, {
                  label: "Produto",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      (_ctx.state.cameraDisponivel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Ler código pela Câmera"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ant-btn ant-btn-primary ant-btn-block ss-alinhar-centro",
                                  disabled: (_ctx.state.itemContagem.codigo > 0),
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.apresentarLeitorCodigoCamera = true))
                                }, [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_icone, {
                                      nome: "scan",
                                      style: {"font-size":"24px","margin-top":"6px"}
                                    })
                                  ])
                                ], 8, _hoisted_6)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.state.cameraDisponivel?'ant-col ant-col-xs-22 ant-col-xl-23':'ant-col ant-col-xs-24 ant-col-xl-24')
                      }, [
                        _withDirectives(_createElementVNode("a", {
                          class: "ss-apresentar-superior-direito ss-fonte-negrito ss-botao-acima-campo",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.apresentarDetalhesProduto = true))
                        }, [
                          _createVNode(_component_icone, { nome: "informacoes-fp" }),
                          _createTextVNode(" Detalhes")
                        ], 512), [
                          [_vShow, _ctx.state.itemContagem.codigoDefinicao > 0]
                        ]),
                        _createVNode(_component_selecionar_produto, {
                          codigoSelecionado: _ctx.state.itemContagem.codigoDefinicao,
                          "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.itemContagem.codigoDefinicao) = $event)),
                          modoDefinicaoProduto: true,
                          empresas: [_ctx.props.codigoEmpresa],
                          apresentarCodigoInterno: true,
                          placeholder: 'Digite o código interno, código de barras, código personalizado ou descrição do produto...',
                          limparSelecao: false,
                          disabled: (_ctx.state.itemContagem.codigo > 0),
                          codigoParaBusca: _ctx.state.codigoParaBusca,
                          "onUpdate:codigoParaBusca": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.codigoParaBusca) = $event)),
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.obterDadosIdentificacaoDefinicao($event)))
                        }, null, 8, ["codigoSelecionado", "empresas", "placeholder", "disabled", "codigoParaBusca"])
                      ], 2)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_form_item, {
                  label: "Unidade",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input",
                      value: _ctx.state.itemContagem.unidade,
                      readonly: ""
                    }, null, 8, _hoisted_8)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_a_form_item, {
                  label: "Estoque",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_estoque, {
                      empresas: [_ctx.props.codigoEmpresa],
                      tiposProdutos: _ctx.state.identificacaoDefinicao.tipoProduto > 0?[_ctx.state.identificacaoDefinicao.tipoProduto]:[],
                      codigoSelecionado: _ctx.state.itemContagem.codigoEstoque,
                      "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.itemContagem.codigoEstoque) = $event)),
                      disabled: (_ctx.state.itemContagem.codigo > 0)
                    }, null, 8, ["empresas", "tiposProdutos", "codigoSelecionado", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_form_item, {
                  label: "Quantidades contadas",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      valor: _ctx.state.itemContagem.quantidadeContada,
                      "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.itemContagem.quantidadeContada) = $event)),
                      quantidadeCasasDecimais: _ctx.state.itemContagem.casasDecimais,
                      onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.confirmarContagemEstoque()), ["enter"]))
                    }, null, 8, ["valor", "quantidadeCasasDecimais"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    (_ctx.state.mensagemSalvandoContagem !== '')
                      ? (_openBlock(), _createElementBlock("button", _hoisted_13, [
                          _createTextVNode(_toDisplayString(_ctx.state.mensagemSalvandoContagem) + " ", 1),
                          _createVNode(_component_a_spin)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "ant-btn ant-btn-block",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.limparContagem && _ctx.limparContagem(...args)))
                          }, _hoisted_16),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ant-btn ant-btn-block ant-btn-primary",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmarContagemEstoque()))
                          }, _hoisted_18)
                        ]))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["titulo", "class"])
      ]),
      _: 1
    }),
    _createVNode(_component_produto_detalhes, {
      codigoProdutoDefinicao: 1,
      visivel: _ctx.state.apresentarDetalhesProduto,
      "onUpdate:visivel": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.apresentarDetalhesProduto) = $event))
    }, null, 8, ["visivel"]),
    (_ctx.state.cameraDisponivel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_leitor_codigo_camera, {
            visivel: _ctx.state.apresentarLeitorCodigoCamera,
            "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.apresentarLeitorCodigoCamera) = $event)),
            onCodigoIdentificadoNaLeitura: _cache[13] || (_cache[13] = ($event: any) => (_ctx.codigoIdentificadoNaLeitura($event)))
          }, null, 8, ["visivel"])
        ]))
      : _createCommentVNode("", true)
  ]))
}